import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { IconButton, Typography } from '@material-ui/core'
import IconBack from '@material-ui/icons/ArrowBack'
import { injectIntl } from 'react-intl'
import {
  applicationFetchFormData,
  applicationClearStateForm,
  applicationChange,
} from 'reducers/application/reducer'
import { fetchProfile } from 'reducers/profile/reducer'
import ApplicationForm from 'components/application/ApplicationForm'
import withPromise from 'helpers/withPromise'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'
import messages from './translate'

class ApplicationItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
    }
  }

  componentDidMount() {
    const { applicationFetchFormData } = this.props

    applicationFetchFormData({
      entityId: this.getEntityId(),
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      history: { goBack },
    } = this.props

    if (nextState.redirect) {
      goBack()

      return false
    }

    return true
  }

  componentWillUnmount() {
    const { applicationClearStateForm } = this.props

    applicationClearStateForm()
  }

  getEntityId() {
    const {
      match: {
        params: { id },
      },
    } = this.props

    return id !== 'create' ? id : 0
  }

  onSubmit = values => {
    const { applicationChange, fetchProfile } = this.props
    const { translations: formTranslations, active } = values
    const translations = []

    Object.keys(formTranslations).forEach(key => {
      const translation = formTranslations[key]
      translations.push({
        ...translation,
        locale: key,
      })
    })

    return withPromise(applicationChange, {
      entityId: this.getEntityId(),
      values: {
        active,
        translations,
      },
    })
      .then(errors =>
        errors ? Promise.resolve(errors) : this.setState({ redirect: true }),
      )
      .then(() => {
        fetchProfile()
      })
  }

  render() {
    const {
      formData,
      intl: { formatMessage },
      history: { goBack },
    } = this.props

    return (
      <div className="container-fluid no-breadcrumb">
        <Typography variant="h5" className="headline">
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          {formatMessage(messages.application)}
        </Typography>
        <ApplicationForm
          formData={formData}
          onSubmit={this.onSubmit}
          {...this.props}
        />
      </div>
    )
  }
}

ApplicationItem.propTypes = {
  formData: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  intl: REACT_INTL_PROP_TYPE.isRequired,
  applicationFetchFormData: PropTypes.func,
  applicationClearStateForm: PropTypes.func,
  applicationChange: PropTypes.func,
  fetchProfile: PropTypes.func,
}

ApplicationItem.defaultProps = {
  applicationFetchFormData: () => {},
  applicationClearStateForm: () => {},
  applicationChange: () => {},
  fetchProfile: () => {},
}

export default connect(
  state => ({
    formData: state.getIn(['application', 'formData']).toJS(),
  }),
  {
    applicationFetchFormData,
    applicationClearStateForm,
    applicationChange,
    fetchProfile,
  },
)(injectIntl(ApplicationItem))
